"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _showModal["default"];
  }
});
var _showModal = _interopRequireDefault(require("./showModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }